import React from 'react'
import PropTypes from 'prop-types'

import { images } from 'packages/simplesat-config'

const TagsAndCommentSettings = ({
  hideRemoveIntegration,
  tags,
  onChangeGoodTag,
  onChangeNeutralTag,
  onChangeBadTag,
  onClickUpdateSettings,
  onClickDeactivate,
}) => (
  <div>
    <p>
      Updates the Zendesk ticket with a private comment and tag after a response is created or
      changed.
    </p>

    <h5>Example screenshot</h5>

    <img
      className="ui bordered image mb20"
      src={images.zendeskCommentExample}
      alt="zendesk comment rating"
    />

    <form className="ui form">
      <div className="field">
        <label>Tag for positive response</label>
        <input type="text" value={tags.good} onChange={onChangeGoodTag} required />
      </div>

      <div className="field">
        <label>Tag for neutral response</label>
        <input type="text" value={tags.neutral} onChange={onChangeNeutralTag} required />
      </div>

      <div className="field">
        <label>Tag for negative response</label>
        <input type="text" value={tags.bad} onChange={onChangeBadTag} required />
      </div>

      <hr />
      <button className="ui primary button" onClick={onClickUpdateSettings}>
        Update settings
      </button>
      {!hideRemoveIntegration && (
        <button className="ui button" onClick={onClickDeactivate}>
          Remove integration
        </button>
      )}
    </form>
  </div>
)

TagsAndCommentSettings.defaultProps = {
  tags: {},
  comment: '',
}

TagsAndCommentSettings.propTypes = {
  tags: PropTypes.object.isRequired,
  hideRemoveIntegration: PropTypes.bool,
  onChangeGoodTag: PropTypes.func.isRequired,
  onChangeNeutralTag: PropTypes.func.isRequired,
  onChangeBadTag: PropTypes.func.isRequired,
  onClickUpdateSettings: PropTypes.func.isRequired,
  onClickDeactivate: PropTypes.func.isRequired,
}

export default TagsAndCommentSettings



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Admin/Surveys/ZendeskIntegrationSettings/TagsAndCommentSettings/index.js